import React, { type ReactElement } from 'react';
import BaseMarkerBadge from 'feature-components/badges/marker-badges/base-marker-badge';
import { useAuthCustomerUser } from 'services/providers/auth.hooks';
import type { SelectableMarkerBadgeProps } from './selectable-marker-badge';

/**
 * A version of the marker badge that can be used regardless of whether the organisation user has
 * been allocated to a response.
 *
 * Also useful when we don't want want the overhead of fetching marker or mark details just to
 * display an organisation user's details. However, if the user has been allocated, this badge is
 * not as robust in error handling since it does not display a red error badge if there are no
 * TestInstanceResponseMarker records returned from the API for the specified organisation user.
 */
export default function OrganisationUserOnlyMarkerBadge({
  organisationUser,
  warnIfNotCurrentUser,
  omitTooltip = false
}: SelectableMarkerBadgeProps & { omitTooltip?: boolean }): ReactElement {
  const currentOrganisationUser = useAuthCustomerUser();

  return (
    <BaseMarkerBadge
      displayWarning={
        warnIfNotCurrentUser ? organisationUser?.id !== currentOrganisationUser?.id : false
      }
      activeMarker={undefined}
      defaultMarkerToOrganisationUser
      organisationUser={organisationUser}
      autoscored={false} // Only human markers can be filtered/displayed when there is no mark.
      omitTooltip={omitTooltip}
    />
  );
}
